import {yup} from 'libs/yup'
import {PickedFile} from './parts/FilePickerModal'

export const schema = yup.object({
  attachments: yup.array(yup.mixed<File>().file().fileSize()).required(),
  others: yup.array(yup.mixed<PickedFile>().required()).max(10, 'アップロードできるファイルは10件までです').required(),
})

export type Schema = yup.InferType<typeof schema>
